import type { EntryValueViewT } from "@/types/database/entries";

export const sortEntryValuesView = (entryValuesView: EntryValueViewT[]) => {
    if (!entryValuesView) return [];

    // Filter out any undefined or null values
    const filteredValues = entryValuesView.filter((ev) => ev);

    return filteredValues.sort((a, b) => {
        // First sort by page_index
        if ((a.page_index ?? 0) !== (b.page_index ?? 0)) {
            return (a.page_index ?? 0) - (b.page_index ?? 0);
        }
        // Then sort by input_index within the same page
        return (a.input_index ?? 0) - (b.input_index ?? 0);
    });
};
